// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Bf0g","delete":"styles_delete__23WZx","update":"styles_update__3vSvW","add":"styles_add__3CROw"};